export default __webpack_public_path__ + "static/media/dashboard.a369b873.jpg";